import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaRocket, FaHandHoldingUsd, FaUser, FaEnvelope, FaPhone, FaLock } from "react-icons/fa";
import { FcHeadset } from "react-icons/fc";
import { registerUser } from "../../api/api";
import { toast } from "react-toastify";
import AuthLayout from "../layout/AuthLayout";
import AuthBranding from "./AuthBranding";
import FormInput from "./FormInput";
import "../custom.css";

const signupFeatures = [
  { icon: <FaRocket size={22} color="#6FE6B8" />, text: "Quick Setup" },
  { icon: <FaHandHoldingUsd size={22} color="#6FE6B8" />, text: "Low Fees" },
  { icon: <FcHeadset size={22} color="#6FE6B8" />, text: "24/7 Support" },
];

const Signup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let response = await registerUser({
        email: email,
        password: password,
        name: name,
        phoneNumber: phone,
      });
      if (response.success === true) {
        toast.success(response.message);
        navigate("/verifySignup", { state: { email: email, password: password } });
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const contentPanel = (
    <AuthBranding
      accentText="Join"
      titleSuffix="Us"
      subtitle="Create your Binaxpay account to start using our crypto payment gateway services today."
      features={signupFeatures}
    />
  );

  const formPanel = (
    <div className="mt-3">
      <h2>Create Account</h2>
      <p className="form-subtitle">Fill in your details to get started</p>

      <form className="auth-form" id="signupForm" onSubmit={handleSubmit}>
        {/* Full Name */}
        <FormInput
          label="Full Name"
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          icon={<FaUser />}
          required
        />

        {/* Email */}
        <FormInput
          label="Email"
          type="email"
          placeholder="Enter Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          icon={<FaEnvelope />}
          required
        />

        {/* Phone */}
        <FormInput
          label="Phone Number"
          type="tel"
          placeholder="Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          icon={<FaPhone />}
          required
        />

        {/* Password */}
        <FormInput
          label="Password"
          type="password"
          placeholder="Enter Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          icon={<FaLock />}
          required
        />

        {/* Terms & Conditions */}
        <div className="terms">
          <input type="checkbox" id="terms" required />
          <label htmlFor="terms">
            I agree to the <Link to="#">Terms of Service</Link> and{" "}
            <Link to="#">Privacy Policy</Link>
          </label>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="btn btn-signup btn-block"
          disabled={loading}
        >
          {loading ? "Signing Up..." : "Sign Up"}
        </button>

        {/* Footer */}
        <div className="auth-footer">
          Already have an account? <Link to="/signin">Sign in</Link>
        </div>
      </form>
    </div>
  );

  return (
    <AuthLayout
      contentPosition="left"
      contentPanel={contentPanel}
      formPanel={formPanel}
    />
  );
};

export default Signup;
